import React, { createContext, useState, useContext, useEffect } from 'react';

const YearContext = createContext();

export const YearProvider = ({ children }) => {
  // Initialize from localStorage or default to current year
  const [selectedYear, setSelectedYear] = useState(() => {
    const savedYear = localStorage.getItem('selectedYear');
    return savedYear ? parseInt(savedYear, 10) : new Date().getFullYear();
  });

  // Save to localStorage whenever year changes
  useEffect(() => {
    localStorage.setItem('selectedYear', selectedYear.toString());
  }, [selectedYear]);

  const value = {
    selectedYear,
    setSelectedYear
  };

  return (
    <YearContext.Provider value={value}>
      {children}
    </YearContext.Provider>
  );
};

export const useYear = () => {
  const context = useContext(YearContext);
  if (!context) {
    throw new Error('useYear must be used within a YearProvider');
  }
  return context;
};

export default YearContext;
